import React, { useRef, useState } from "react";
import { IoCloudUploadOutline, IoDocumentTextOutline } from "react-icons/io5";
import { MdOutlineFileUpload } from "react-icons/md";
import "../../assets/css/component-rag-files.css";

export default function RagFilesDropzone({ extensions = [], accept = "", onUpload, disabled }) {
  const [dragging, setDragging] = useState(false);
  const [selected, setSelected] = useState(null);
  const inputRef = useRef(null);

  const formatLabel =
    extensions.length > 0 ? extensions.map((e) => e.toUpperCase()).join(", ") : "";

  const handleFile = (file) => {
    if (!file) return;
    setSelected(file);
    if (onUpload) onUpload(file);
  };

  const handleServerInteraction = () => {
    if (disabled) return;
    inputRef.current?.click();
  };

  return (
    <div
      className={`rag-dropzone ${dragging ? "rag-dropzone--active" : ""}`}
      onDragOver={(e) => {
        e.preventDefault();
        if (!disabled) setDragging(true);
      }}
      onDragLeave={() => setDragging(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDragging(false);
        if (!disabled) handleFile(e.dataTransfer.files?.[0]);
      }}
      onClick={handleServerInteraction}
    >
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        style={{ display: "none" }}
        onChange={(e) => handleFile(e.target.files?.[0])}
      />
      <IoCloudUploadOutline className="rag-dropzone__icon" />
      {selected ? (
        <p className="rag-dropzone__title">{selected.name}</p>
      ) : (
        <>
          <p className="rag-dropzone__title">Glissez-déposez vos documents ici</p>
          <span className="rag-dropzone__divider">ou</span>
          <button
            type="button"
            className="btn btn-primary d-inline-flex align-items-center justify-content-center gap-2"
            onClick={handleServerInteraction}
          >
            <MdOutlineFileUpload size={18} />
            Parcourir les fichiers
          </button>
        </>
      )}
      {formatLabel ? (
        <small className="text-muted d-inline-flex align-items-center justify-content-center gap-1 mt-3">
          <IoDocumentTextOutline />
          {formatLabel}
        </small>
      ) : null}
    </div>
  );
}
